import Client from './Clients/AxiosClient'
const resource = '/testOrder'

export default {
  get() {
    return Client.get(`${resource}`)
  },
  getDeleted() {
    return Client.get(`${resource}?status=false`)
  },
  getTest(id) {
    return Client.get(`${resource}/${id}`)
  },
  delete(id) {
    return Client.put(`${resource}/status/${id}`, { status: false })
  },
  reactivate(id) {
    return Client.put(`${resource}/status/${id}`, { status: true })
  },
}
